import React, { useEffect, useState } from "react";
import "../assets/public/News.css";
import { useFirebase } from "../providers/firebase";

const News = () => {
  const { publications } = useFirebase();
  const [recentPublications, setRecentPublications] = useState([]);
  const [startIndex, setStartIndex] = useState(0);
  const [isDataFetched, setIsDataFetched] = useState(false);

  const BATCH_SIZE = 3;

  useEffect(() => {
    const list = publications?.recentConferences;

    if (Array.isArray(list) && list.length > 0) {
      setIsDataFetched(true);

      const items = list; // use full list (or list.slice(0, 5) if you want)
      setRecentPublications(items);
      setStartIndex(0);

      const interval = setInterval(() => {
        setStartIndex((prev) => (prev + BATCH_SIZE) % items.length);
      }, 9000);

      return () => clearInterval(interval);
    }
  }, [publications]);

  const n = recentPublications.length;
  const currentBatch =
    n === 0
      ? []
      : Array.from({ length: Math.min(BATCH_SIZE, n) }, (_, i) => {
          return recentPublications[(startIndex + i) % n];
        });

  return (
    <div className="flash-container">
      {isDataFetched ? (
        <ul>
          <h3>Recent Publications</h3>
          {currentBatch.map((item, idx) => (
            <li className="flash-text" key={`${startIndex}-${idx}`}>
              {item}
            </li>
          ))}
        </ul>
      ) : (
        <p>Loading news...</p>
      )}
    </div>
  );
};

export default News;